<template>
  <div class="nav-footer">
    <!-- 定宽布局 -->
    <div class="container">
      <!-- 联系方式-->
      <div class="f-info">
        <h2>联系方式</h2>
        <div class="blink"></div>
        <ul>
          <li class="iconfont icon-jigou">公司： 北京点思传媒有限公司</li>
          <li class="iconfont icon-weibiaoti">电话：010-60845963</li>
          <!-- <li class="iconfont">邮箱：hshsh1020@163.com</li> -->
          <li class="iconfont">
            <a href="https://beian.miit.gov.cn/#/Integrated/index">ICP备： 京ICP备2024065152号-2</a>
          </li>
          <li class="iconfont icon-dizhi">
            地址：北京市朝阳区望京广顺北大街与来广营西路交汇处诚盈中心5号楼506室

          </li>
          <li>
            <a href="https://beian.mps.gov.cn/#/query/webSearch">联网备案号：京公网安备11010502055269号</a>
          </li>
        </ul>
      </div>
      <!-- 公司简介 -->
      <div class="f-jj">
        <h2>北京点思传媒有限公司</h2>
        <div class="blink"></div>
        <p>
          经营范围包括一般项目：电影摄制服务；销售代理；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；软件外包服务；广告设计、代理；广告发布等......
        </p>
      </div>
      <!-- 导航栏 -->
      <div class="f-list">
        <h2>导航栏</h2>
        <div class="blink"></div>
        <ul>
          <li><a href="/">行业资讯</a></li>
          <!-- <li><a href="/#/ac1">最新热门</a></li> -->
          <!-- <li><a href="/#/ac2">行业资讯</a></li> -->
          <li><a href="/#/info">关于我们</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-footer",
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.nav-footer {
  width: 100%;
  height: 350px;
  background: #2d3237;

  margin-top: 40px;

  .container {
    height: 100%;
    @include flex();

    // 联系方式
    .f-info {
      h2 {
        font-size: 18px;
        color: #fff;
      }

      .blink {
        width: 100px;
        height: 3px;
        background-color: #fff;
        margin: 20px 0;
      }

      ul {
        li {
          width: 300px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.4);
          margin: 10px 0;

          a {
            color: rgba(255, 255, 255, 0.4);
            font-size: 14px;
          }
        }
      }
    }

    // 公司简介
    .f-jj {
      width: 400px;

      h2 {
        font-size: 18px;
        color: #fff;
      }

      .blink {
        width: 100px;
        height: 3px;
        background-color: #fff;
        margin: 20px 0;
      }

      p {
        color: rgba(255, 255, 255, 0.4);
        font-size: 14px;
        line-height: 30px;
      }
    }

    // 导航栏
    .f-list {
      h2 {
        font-size: 18px;
        color: #fff;
      }

      .blink {
        width: 100px;
        height: 3px;
        background-color: #fff;
        margin: 20px 0;
      }

      ul {
        li {
          width: 200px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.4);
          margin: 10px 0;

          a {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.4);
          }
        }
      }
    }
  }
}
</style>